<template>
  <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
  <v-card class="mx-auto mt-12">
    <v-toolbar color="secondary" dark>
      <v-toolbar-title>Select Account</v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>-->
    </v-toolbar>
    <v-list>
      <v-list-item v-for="item in businesses.data" :key="item.id">
        <v-list-item-icon>
          <v-icon v-if="item.icon" color="primary">mdi-star</v-icon>
        </v-list-item-icon>
        <v-btn text icon color="indigo">
          <v-icon>mdi-star</v-icon>
        </v-btn>
        <v-list-item-content>
          <v-list-item-title> {{ item.name }}</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn @click="selectBusiness(item.id)" class="primary">
            Select
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
export default {
  props: {
    businesses: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    selectBusiness(id) {
      this.$store.dispatch("setBusiness", id);
      this.$router.push("/dashboard");
    }
  }
};
</script>
